<script lang="ts">
    import { createAccordion } from '@melt-ui/svelte';
    import { slide } from 'svelte/transition';
    import {
        VpAddIcon,
        VpSubtractIcon,
    } from '@decathlon-experience/icons/svelte';

    import { defaultFormValues } from '$saga/views/Search/constants';
    import Slider from '$saga/components/Slider.svelte';
    import MultiSelectFilter from '$saga/views/Search/Filters/MultiSelectFilter.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    const {
        elements: { content, item, trigger, root },
        helpers: { isSelected },
    } = createAccordion({
        defaultValue: undefined,
    });
</script>

<div {...$root}>
    <!--levels-->
    <div {...$item('levels')} use:item>
        <button
            {...$trigger('levels')}
            class="flex w-full items-center justify-between border-t border-solid border-border-quiet py-m"
            use:trigger
        >
            <span class="flex items-center gap-xs">
                Niveau sportif
                <!--if filter has changed value  -->
                {#if $filtersContext.formValues.levels.length > 0}
                    <div
                        class="size-m rounded-full bg-blue-brand text-xs text-white"
                    >
                        {$filtersContext.formValues.levels.length}
                    </div>
                {/if}
            </span>
            {#if $isSelected('levels')}
                <VpSubtractIcon size={16} />
            {:else}
                <VpAddIcon size={16} />
            {/if}
        </button>
        {#if $isSelected('levels')}
            <div
                class="text-sm"
                {...$content('levels')}
                use:content
                transition:slide
            >
                <MultiSelectFilter
                    options={$filtersContext.defaultLevels ?? []}
                    bind:formValue={$filtersContext.formValues.levels}
                />
            </div>
        {/if}
    </div>
    <!--types-->
    <div {...$item('types')} use:item>
        <button
            {...$trigger('types')}
            class="flex w-full items-center justify-between border-t border-solid border-border-quiet py-m"
            use:trigger
        >
            <span class="flex items-center gap-xs">
                Type de séjour
                <!--if filter has changed value  -->
                {#if $filtersContext.formValues.types.length > 0}
                    <div
                        class="size-m rounded-full bg-blue-brand text-xs text-white"
                    >
                        {$filtersContext.formValues.types.length}
                    </div>
                {/if}
            </span>
            {#if $isSelected('types')}
                <VpSubtractIcon size={16} />
            {:else}
                <VpAddIcon size={16} />
            {/if}
        </button>
        {#if $isSelected('types')}
            <div
                class="text-sm"
                {...$content('types')}
                use:content
                transition:slide
            >
                <MultiSelectFilter
                    options={$filtersContext.defaultTypes ?? []}
                    bind:formValue={$filtersContext.formValues.types}
                />
            </div>
        {/if}
    </div>

    <!--budget-->
    <div {...$item('budget')} use:item>
        <button
            {...$trigger('budget')}
            class="flex w-full items-center justify-between border-t border-solid border-border-quiet py-m"
            use:trigger
        >
            <span class="flex items-center gap-xs">
                Budget par personne
                <!--if filter has changed value  -->
                {#if $filtersContext.formValues.budgetMin !== defaultFormValues.budgetMin || $filtersContext.formValues.budgetMax !== defaultFormValues.budgetMax}
                    <div
                        class="size-m rounded-full bg-blue-brand text-xs text-white"
                    >
                        1
                    </div>
                {/if}
            </span>
            {#if $isSelected('budget')}
                <VpSubtractIcon size={16} />
            {:else}
                <VpAddIcon size={16} />
            {/if}
        </button>
        {#if $isSelected('budget')}
            <div
                class="text-sm"
                {...$content('budget')}
                use:content
                transition:slide
            >
                <div class="p-s">
                    <Slider
                        label="€"
                        bind:valueMin={$filtersContext.formValues.budgetMin}
                        bind:valueMax={$filtersContext.formValues.budgetMax}
                        defaultMax={$filtersContext.defaultBudgetMax}
                    />
                </div>
            </div>
        {/if}
    </div>

    <!--duration-->
    <div {...$item('duration')} use:item>
        <button
            {...$trigger('duration')}
            class="flex w-full items-center justify-between border-t border-solid border-border-quiet py-m"
            use:trigger
        >
            <span class="flex items-center gap-xs">
                Durée du séjour
                <!--if filter has changed value  -->
                {#if $filtersContext.formValues.durationMin !== defaultFormValues.durationMin || $filtersContext.formValues.durationMax !== defaultFormValues.durationMax}
                    <div
                        class="size-m rounded-full bg-blue-brand text-xs text-white"
                    >
                        1
                    </div>
                {/if}
            </span>
            {#if $isSelected('duration')}
                <VpSubtractIcon size={16} />
            {:else}
                <VpAddIcon size={16} />
            {/if}
        </button>
        {#if $isSelected('duration')}
            <div
                class="text-sm"
                {...$content('duration')}
                use:content
                transition:slide
            >
                <div class="p-s">
                    <Slider
                        label="j"
                        bind:valueMin={$filtersContext.formValues.durationMin}
                        bind:valueMax={$filtersContext.formValues.durationMax}
                        defaultMax={$filtersContext.defaultDurationMax}
                    />
                </div>
            </div>
        {/if}
    </div>

    <!--tags-->
    <div {...$item('tags')} use:item>
        <button
            {...$trigger('tags')}
            class="flex w-full items-center justify-between border-b border-t border-solid border-border-quiet py-m"
            use:trigger
        >
            <span class="flex gap-xs">
                Thème
                <!--if filter has changed value  -->
                {#if $filtersContext.formValues.tags.length > 0}
                    <div
                        class="mb-auto size-m rounded-full bg-blue-brand text-xs text-white"
                    >
                        {$filtersContext.formValues.tags.length}
                    </div>
                {/if}
            </span>
            {#if $isSelected('tags')}
                <VpSubtractIcon size={16} />
            {:else}
                <VpAddIcon size={16} />
            {/if}
        </button>
        {#if $isSelected('tags')}
            <div
                class="text-sm"
                {...$content('tags')}
                use:content
                transition:slide
            >
                <MultiSelectFilter
                    options={$filtersContext.defaultTags ?? []}
                    bind:formValue={$filtersContext.formValues.tags}
                />
            </div>
        {/if}
    </div>
</div>
